import { FormOutlined } from "@payping/icons";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";
import { Button, Col, Descriptions, Image, Row, Space, Typography } from "@payping/web-components";
import { FC } from "react";
import { useAppDispatch, useAppSelector } from "@/utils";
import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useAsyncRetry } from "react-use";
import { getPersonalInfo, getUserPhoneNumber } from "@payping/redux/actions";

const PersonalList: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation();
  const personalInfo = useAppSelector((state) => state.user.personalInfo);
  const personalDocuments = useAppSelector((state) => state.user.personalInfo?.documents);
  const navigate = useNavigate();

  useAsyncRetry(async () => {
    await dispatch(getPersonalInfo());
    await dispatch(getUserPhoneNumber());
  }, [dispatch]);

  return (
    <Row>
      <Col span={24}>
        <Descriptions
          className="tw:w-full"
          column={2}
          size={"middle"}
          title={
            <div className={"tw:flex tw:w-full tw:flex-row tw:justify-between"}>
              <Typography.Title className="tw:font-medium" level={4}>
                {t("profile.main.personal")}
              </Typography.Title>
              <Button
                type={"primary"}
                icon={<FormOutlined width={14} height={14} />}
                onClick={() => navigate(DashboardRoutes.settings.personal.edit.url)}
              >
                {t("edit")}
              </Button>
            </div>
          }
        >
          <Descriptions.Item label={t("firstName")}>{personalInfo?.firstName}</Descriptions.Item>
          <Descriptions.Item label={t("lastName")}>{personalInfo?.lastName}</Descriptions.Item>
          <Descriptions.Item label={t("profile.fatherName")}>{personalInfo?.fatherName}</Descriptions.Item>
          <Descriptions.Item label={t("phoneNumber")}>{personalInfo?.phoneNumber}</Descriptions.Item>
          <Descriptions.Item label={t("birthDate")}>
            {
              toJalali({
                date: personalInfo?.birthDate,
                toFormat: dateFormats.ui.jalaliDate,
              }).string
            }
          </Descriptions.Item>
          <Descriptions.Item label={t("profile.birthCertificateNumber")}>
            {personalInfo?.birthCertificateNumber}
          </Descriptions.Item>
          <Descriptions.Item label={t("nationalCode")}>{personalInfo?.nationalCode}</Descriptions.Item>
          <Descriptions.Item label={t("email")}>{personalInfo?.email}</Descriptions.Item>
        </Descriptions>
      </Col>
      <Col span={24} className={"tw:mt-8!"}>
        <Space orientation={"vertical"} size={"large"}>
          <Typography.Text type={"secondary"}>{t("settings.nationalIdAndCodePhoto")}</Typography.Text>
          <Space size={"middle"}>
            {personalDocuments?.map((images, i) => (
              <Image key={i} width={100} src={images.serverName} />
            ))}
          </Space>
        </Space>
      </Col>
    </Row>
  );
};

export default PersonalList;
